import { __assign } from "tslib";
import * as VideoGallerySDK from '@wix/video-gallery-sdk';
import { wixImageToProGallery, wixCodeItemsToProGallery, } from '@wix/pro-gallery-items-formatter';
var useHLS = true; // TODO - add this functionality to the function arguments if we want to control it by some toggle.
function converItemsToProGalleryItems(items, itemsSrc) {
    if (itemsSrc === 'wixSDK') {
        items = wixCodeItemsToProGallery(items);
    }
    else if (itemsSrc === 'organizeMedia') {
        items = items.map(wixImageToProGallery);
    }
    return items;
}
function processItems(items) {
    return prepareAndSetItems({
        newItems: items,
    });
}
function prepareAndSetItems(_a, callback) {
    var newItems = _a.newItems, _b = _a.currentItems, currentItems = _b === void 0 ? [] : _b;
    var _c = prepareItems(newItems), itemsToSet = _c.itemsToSet, shouldGetVideoUrls = _c.shouldGetVideoUrls;
    var _items = currentItems.concat(itemsToSet);
    if (typeof callback === 'function') {
        callback(_items);
    }
    return { items: currentItems.concat(itemsToSet), shouldGetVideoUrls: shouldGetVideoUrls };
}
function prepareItems(items) {
    // TODO - make item properties be added only once - this is getting bigger.
    var shouldGetVideoUrls = false;
    var itemsToSet;
    try {
        itemsToSet = items.map(function (item) {
            var _a = addItemProperties(item), resItem = _a.item, convertedToPlaceholder = _a.convertedToPlaceholder;
            if (!shouldGetVideoUrls && convertedToPlaceholder) {
                shouldGetVideoUrls = true;
            }
            if (typeof resItem.metaData === 'string') {
                // TODO - check this.... this moved from the itemsHelper.
                try {
                    resItem = __assign(__assign({}, resItem), { metaData: JSON.parse(resItem.metaData) });
                }
                catch (e) {
                    console.error('Failed parse item metaData', e);
                }
            }
            return resItem;
        });
    }
    catch (e) {
        console.error('corrupt items', items, 'returning old items instead', e);
    }
    return { itemsToSet: itemsToSet, shouldGetVideoUrls: shouldGetVideoUrls };
}
function callServerToGetUrls(_a, callback) {
    var newItems = _a.newItems, _b = _a.currentItems, currentItems = _b === void 0 ? [] : _b;
    getItemsWithWixVideosUrls(newItems).then(function (itemsWithVideoUrls) {
        prepareAndSetItems({
            newItems: itemsWithVideoUrls,
            currentItems: currentItems,
        }, callback);
    });
}
function addItemProperties(item) {
    var convertedToPlaceholder = false;
    if (isUnreadyVideoFile(item)) {
        item = replaceByPlaceHolder(item);
        convertedToPlaceholder = true;
    }
    return { item: item, convertedToPlaceholder: convertedToPlaceholder };
}
function isUnreadyVideoFile(item) {
    return (!item.metaData.ghostItem &&
        ((item.metaData.videoUrl &&
            item.metaData.videoUrl.includes('wix:video://')) ||
            (item.metaData.type === 'video' &&
                item.mediaUrl &&
                !item.metaData.videoUrl)));
}
function replaceByPlaceHolder(item) {
    return {
        itemId: item.itemId,
        mediaUrl: item.metaData.posters[0].url,
        orderIndex: 0,
        metaData: __assign(__assign({}, item.metaData), { type: 'image', isVideoPlaceholder: true, height: item.metaData.posters[0].height, width: item.metaData.posters[0].width }),
    };
}
function getItemsWithWixVideosUrls(items) {
    var result = items.map(function (item) {
        if (isUnreadyVideoFile(item)) {
            return getItemWithVideoUrls(item);
        }
        else {
            return Promise.resolve(item);
        }
    });
    return Promise.all(result);
}
function getItemWithVideoUrls(item) {
    var videoId = getVideoMediaId(item);
    return VideoGallerySDK.getVideoURLs(videoId)
        .then(function (qualities) {
        item.metaData.qualities = qualities
            .filter(function (quality) { return quality.type === 'MP4'; })
            .map(function (qualityObject) {
            var url = qualityObject.url;
            var quality = qualityObject.quality;
            var height = parseInt(quality);
            var width = Math.floor((height * item.metaData.width) / item.metaData.height);
            return {
                url: url,
                height: height,
                width: width,
                quality: quality,
                formats: ['mp4'],
            };
        });
        item.metaData.videoUrl = undefined;
        if (useHLS) {
            var hls = qualities.filter(function (quality) { return quality.type === 'HLS'; });
            if (hls.length > 0) {
                item.metaData.videoUrl = hls[0].url;
            }
        }
        else {
            item.metaData.ghostItem = true; // see below. this is here just for the experiment to have an "else" and not stay placeholder.
        }
        return item;
    })
        .catch(function (e) {
        item.metaData.ghostItem = true; // item does not exist but is still in the pg database
        return item;
    });
}
function getVideoMediaId(item) {
    if (item.metaData.videoUrl &&
        item.metaData.videoUrl.includes('wix:video://')) {
        return item.metaData.videoUrl.split('/')[3] || item.itemId;
    }
    else {
        return item.mediaUrl;
    }
}
export { callServerToGetUrls, processItems, converItemsToProGalleryItems };
//# sourceMappingURL=itemsProcessor.js.map